<template>
  <br />
  <SimpleWizard/>
</template>

<!-- Unicamente distinguimos entre una petición de póliza existente y un nuevo seguro -->

<script>
  // import api from '@/axios';
  import { useSeguroStore } from '@/stores/seguroStore';
  import SimpleWizard from "./wizardNuevoSeguro.vue";

  export default {
    setup() {
        const store = useSeguroStore();
        return { store };
    },
    data() {
        return {
            errors: [],
        };
    },
    // Importar el componente del wizard
    components: {
      SimpleWizard
    },

    // Navegación y lógica de envío
    methods: {
      // Aquí podrías agregar métodos para manejar la navegación entre pasos y el envío final del formulario
    }
  };

</script>
